import { createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import rootReducer from './reducers';
 
 
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['userLoginStatus','loggedinUserInfo','authUserPermission','tokenValue', 'currentPropertyId']
}
 
const persistedReducer = persistReducer(persistConfig, rootReducer)
let store = createStore(persistedReducer)
let persistor = persistStore(store)
// export default () => {
  
//   return { store, persistor }
// }
export { persistor };
export default store  ; 